import React from 'react';
import { useTranslation } from 'react-i18next';
import PageWrapper from 'commons/src/components/containers/PageWrapper';
import WhiteSectionContainer from 'commons/src/components/containers/WhiteSectionContainer';
import SectionHeader from 'commons/src/components/headers/SectionHeader';
import styles from './AccountThresholdsPage.module.scss';
import CustomThresholds from './CustomThresholdSection';
import ThresholdMgmt from './ThresholdMgmt';

export const AccountThresholdsPage = (): React.ReactElement => {
    const { t: txt } = useTranslation();
    return (
        <PageWrapper pageType="medium">
            <SectionHeader headerName="CustomThresholds.SensorThresholds" headerType={3} initialHeader />
            <p className={styles.p}>{txt('CustomThresholds.AccountDescription')}</p>
            <WhiteSectionContainer>
                <CustomThresholds />
                <ThresholdMgmt />
            </WhiteSectionContainer>
        </PageWrapper>
    );
};

export default AccountThresholdsPage;
